<template>
  <SubsectionNavBottom
    class="section--top"
    parent="E2E Solutions"
    :sidebar="sidebar"
    :subSections="subSections">
    <router-view></router-view>
  </SubsectionNavBottom>
</template>

<script>
import SubsectionNavBottom from '@/layout/SubsectionNavBottom.vue';

export default {
  name: 'End To End',
  props: {
    sidebar: Boolean,
  },
  components: {
    SubsectionNavBottom,
  },
  computed: {
    subSections() {
      /**
       * The url key inside each element MUST match the router path
       * see: @/router/index.js
       */
      return [
        {
          label: this.$i18n.t('end-to-end.submenu.workflow'),
          shareLabel: 'Workflow',
          url: '',
        },
        {
          label: this.$i18n.t('end-to-end.submenu.service-support'),
          shareLabel: 'Service and Support',
          url: 'service-and-support',
        },
      ];
    },
  },
};
</script>
